module.exports = __webpack_public_path__ + "static/ace-231996afa7b5f1cc056adf4800c1e8c7.jpeg";